import React from "react";
import { BooleanField } from "react-admin";
import { List, Datagrid, TextField, EditButton, ShowButton, DeleteButton } from "react-admin";
import { EmptyList } from "common/components";

import getFilters from "./Filter";

const ListVersionObjects = ({ mode }) => {
  let title;
  let isPage;

  switch (mode) {
    case "page":
      title = "Списък със страница";
      isPage = true;
      break;
    case "component":
      title = "Списък със компонент";
      isPage = false;
      break;
    default:
  }

  return (
    <List
      title={title}
      hasCreate
      exporter={false}
      filters={getFilters(mode)}
      queryOptions={{ meta: { mixed_provider: true } }}
    >
      <Datagrid
        empty={<EmptyList />}
        bulkActionButtons={false}
      >
        <TextField
          source="id"
          sortable={false}
        />
        <TextField
          label="Име"
          source="name"
          sortable={false}
        />
        {isPage && (
          <TextField
            label="Адрес"
            source="route"
            sortable={false}
          />
        )}
        {isPage && (
          <BooleanField
            label="Вътрешен път?"
            source="isInternal"
            sortable={false}
          />
        )}
        {isPage && (
          <TextField
            source="language"
            label="Език"
            sortable={false}
          />
        )}
        <ShowButton />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};

export default ListVersionObjects;
